import * as React from 'react';
import { Stack, Switch, Tooltip } from '@mui/joy';
import PersonIcon from '@mui/icons-material/Person';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export default function OperatorToggle({
  isHumanOperator,
  selectedChatId,
  tenant_id,
  sucursal_id,
  agent_name,
  sendCustomMessage,
  getConversation,
  updateConversation,
}) {
  const [localOperatorState, setLocalOperatorState] = React.useState(isHumanOperator);

  React.useEffect(() => {
    setLocalOperatorState(isHumanOperator);
  }, [isHumanOperator]);

  const handleToggle = async (event) => {
    const newOperatorState = event.target.checked;
    const status = newOperatorState ? 'hablando_con_operador' : 'esperando_consulta_ia';

    try {
      await updateConversation({
        user_id: selectedChatId,
        status: status,
        tenant_id: tenant_id,
        sucursal_id: sucursal_id,
      });

      if (status === 'esperando_consulta_ia') {
        await sendCustomMessage({
          user_id: selectedChatId,
          sucursal_id: sucursal_id,
          message: 'El operador ha finalizado la conversación. Nuestro asistente virtual está disponible para continuar ayudándote con tus consultas.',
          agent_name: agent_name,
        });
      }

      setLocalOperatorState(newOperatorState);
      
      await getConversation(selectedChatId, tenant_id, sucursal_id);
    } catch (error) {
      console.error('Error toggling operator state:', error);
      setLocalOperatorState(!newOperatorState);
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Tooltip title={localOperatorState ? "Operador atendiendo" : "Asistente virtual atendiendo"}>
        <Stack direction="row" spacing={1} alignItems="center">
          {localOperatorState ? (
            <PersonIcon fontSize="small" />
          ) : (
            <SmartToyIcon fontSize="small" />
          )}
          <Switch
            size="sm"
            checked={localOperatorState}
            onChange={handleToggle}
            color={localOperatorState ? 'success' : 'neutral'}
          />
        </Stack>
      </Tooltip>
    </Stack>
  );
}
